import { render, staticRenderFns } from "./deviceTongdao.vue?vue&type=template&id=21f54fdd&scoped=true"
import script from "./deviceTongdao.vue?vue&type=script&lang=js"
export * from "./deviceTongdao.vue?vue&type=script&lang=js"
import style0 from "./deviceTongdao.vue?vue&type=style&index=0&id=21f54fdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f54fdd",
  null
  
)

export default component.exports